import { render, staticRenderFns } from "./version-control.vue?vue&type=template&id=49a2a221"
var script = {}
import style0 from "./version-control.vue?vue&type=style&index=0&id=49a2a221&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports